import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// QR APIS
// ================================

// 🔹 CREATE QR
export async function createQr(
  user_qr_user,
  user_qr_title,
  user_qr_parent,
  user_qr_parent_type,
  user_qr_link,
  user_qr_camp,
  user_qr_note
) {
  try {
    const fd = new FormData();
    fd.append("user_qr_user", user_qr_user);
    fd.append("user_qr_title", user_qr_title);
    fd.append("user_qr_parent", user_qr_parent);
    fd.append("user_qr_parent_type", user_qr_parent_type);
    fd.append("user_qr_link", user_qr_link);
    fd.append("user_qr_camp", user_qr_camp);
    fd.append("user_qr_note", user_qr_note);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}qrapis/create_qr`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createQr error:", error);
    return { status: false, type: "danger", success: "QR creation failed" };
  }
}

// 🔹 QR KPI STATS
export async function getQrKpiStats(qr_id) {
  try {
    const fd = new FormData();
    fd.append("qr_id", qr_id!=undefined?qr_id:"");
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);
    

    const response = await axios.post(`${apiBaseUrl}qrapis/qr_kpi_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getQrKpiStats error:", error);
    return { status: false, type: "danger", success: "Failed to load QR stats" };
  }
}

// 🔹 SCAN TREND
export async function getScanTrend(qr_id) {
  try {
    const fd = new FormData();
    fd.append("qr_id",  qr_id!=undefined?qr_id:"");
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}qrapis/scan_trend`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getScanTrend error:", error);
    return { status: false, type: "danger", success: "Failed to load scan trend" };
  }
}

// 🔹 DEVICE BREAKDOWN
export async function getDeviceBreakdown(qr_id) {
  try {
    const fd = new FormData();
    fd.append("qr_id",  qr_id!=undefined?qr_id:"");
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}qrapis/device_breakdown`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getDeviceBreakdown error:", error);
    return { status: false, type: "danger", success: "Failed to load device breakdown" };
  }
}

// 🔹 RECENT SCANS
export async function getRecentScans(qr_id,page) {
  try {
    const fd = new FormData();
    fd.append("qr_id",  qr_id!=undefined?qr_id:"");
    fd.append("page", page+"");
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}qrapis/recent_scans`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getRecentScans error:", error);
    return { status: false, type: "danger", success: "Failed to load recent scans" };
  }
}

// 🔹 GET QR LIST
export async function getQrList(user_id, limit = 0) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("limit", limit);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}qrapis/getList`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getQrList error:", error);
    return { status: false, type: "danger", success: "Failed to load QR list" };
  }
}

// 🔹 DELETE QR
export async function deleteQr(qr_id, user_id) {
  try {
    const fd = new FormData();
    fd.append("qr_id", qr_id);
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}qrapis/delete_qr`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteQr error:", error);
    return { status: false, type: "danger", success: "QR deletion failed" };
  }
}

export async function getQrUrl(user_qr_link, rtype, uid, user_id) {
  try {
    const fd = new FormData();
    fd.append("user_qr_link", user_qr_link);
    fd.append("rtype", rtype);
    fd.append("uid", uid);
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}qrapis/get_qr_link`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteQr error:", error);
    return { status: false, type: "danger", success: "QR deletion failed" };
  }
}